var _defs, _polyline, _polyline2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomcutsqure01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-13,.cls-12{fill:#fff;stroke:#000;stroke-miterlimit:10;}.cls-13{stroke-width:2.92px;}.cls-12{stroke-width:1.02px;stroke-dasharray:4.07;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "360.17 172.58 360.17 347.42 62.83 347.42 62.83 172.58"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "356.17 172.58 356.17 342.69 66.83 342.69 66.83 172.58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomcutsqure01);
export default __webpack_public_path__ + "static/media/BOTTOM CUT SQURE-01.db94c25624eb361f986e56eb2dd21fc9.svg";
export { ForwardRef as ReactComponent };